<template>
  <div>
    <VendorCards />

    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
import VendorCards from "./components/VendorCards.vue";
export default {
  components: {
    VendorCards,
  },

  computed: {
    ...mapState("auth", ["userData"]),
    ...mapState("affiliate", {
      getVendor: "getVendor",
    }),
  },
  async mounted() {
    let loader = this.$loading();
    await this.$store.dispatch("affiliate/getVendorById", {
      userId: this.userData._id,
    });

    await this.$store.dispatch("affiliate/orderCount", {
      brandId: this.getVendor.vendor.brandId._id,
    });
    loader.close();
  },
};
</script>
